import { bl_inv_reset_moving_average_cost_RowClass } from '../../../dbschema/bl_inv_reset_moving_average_cost.model';
import { BaseContainerModel } from '../../base-container.model';


export class InvResetMovingAverageCostModel extends BaseContainerModel {
  bl_inv_reset_moving_average_cost: bl_inv_reset_moving_average_cost_RowClass = new bl_inv_reset_moving_average_cost_RowClass();
}
